import { createSelector } from 'reselect';

const getI18NState = state => state.i18n;

// eslint-disable-next-line import/prefer-default-export
export const getLanguage = createSelector(
    getI18NState,
    state => state.language,
);
